import React from 'react';

const LiveIcon = () => (
  <img
    src="/images/live_time.png"
    alt="Live"
    style={{ width: '2rem', height: '2rem', objectFit: 'contain' }}
  />
);

const HeuteIcon = () => (
  <img
    src="/images/haute.png"
    alt="Heute"
    style={{ width: '2rem', height: '2rem', objectFit: 'contain' }}
  />
);

const FootballIcon = () => (
  <img
    src="/images/soccer.png"
    alt="Fußball"
    style={{ width: '2rem', height: '2rem', objectFit: 'contain' }}
  />
);


const BasketballIcon = () => (
  <img
    src="/images/basketball.png"
    alt="Basketball"
    style={{ width: '2rem', height: '2rem', objectFit: 'contain' }}
  />
);

const TennisIcon = () => (
  <img
    src="/images/tennis.png"
    alt="Tennis"
    style={{ width: '2rem', height: '2rem', objectFit: 'contain' }}
  />
);

interface NavTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const NavTabs: React.FC<NavTabsProps> = ({ activeTab, onTabChange }) => {

  const tabs = [
    { id: 'live', label: 'Live', icon: <LiveIcon /> },
    { id: 'today', label: 'Heute', icon: <HeuteIcon /> },
    { id: 'football', label: 'Fußball', icon: <FootballIcon /> },
    { id: 'basketball', label: 'Basketball', icon: <BasketballIcon /> },
    { id: 'tennis', label: 'Tennis', icon: <TennisIcon /> },
  ];

  return (
    <nav className="bg-transparent overflow-x-auto scrollbar-hide pb-[5px]">
      <div className="flex gap-5 px-4 justify-between">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center px-2 py-2 rounded-xl whitespace-nowrap transition-all duration-200 ${activeTab === tab.id && activeTab !== ''
              ? 'bg-white/15 text-white scale-105 shadow-sm'
              : 'text-white/80 hover:text-white hover:bg-white/5'
              }`}
          >
            <div className="w-8 h-8 flex items-center justify-center">{tab.icon}</div>
            <span className="text-[13px] font-semibold tracking-wide">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default NavTabs;
